<template>
  <div>
    <b-modal @show="clean" id="addProducto" v-model="ver" size="lg" ref="modal" no-close-on-backdrop no-close-on-esc>
      <template #modal-header>
        <span> <b-icon-archive-fill /> Agregar Paquete</span>
      </template>

      <b-alert v-show="Pak.Contenido.length == 0" variant="warning" :show="true"> <b-icon-exclamation-diamond-fill /> No hay contenido!</b-alert>
      <b-table-lite @row-clicked="onRowClick" table-variant="warning" head-variant="dark" hover bordered small :items="Pak.Contenido">
        <template #cell(Producto)="row">
          {{ row.item.Producto.Nombre }}
        </template>
      </b-table-lite>

    

      <template #modal-footer>
        <div class="w-100">
          <b-input-group v-show="Pak.Contenido.length > 0" size="sm" prepend="Peso">
            <b-form-input size="sm" type="number" v-model="Peso"></b-form-input>
            <b-input-group-prepend><b-input-group-text>Cobro</b-input-group-text></b-input-group-prepend>
            <b-form-input size="sm" type="number" v-model="Pak.Cobro"></b-form-input>
          </b-input-group>
        </div>

        <add-contenido @onAddContenido="onAgregarContenido" />
        <b-button @click="cerrar" variant="primary" size="sm">Cerrar</b-button>

        <b-button :disabled="!PuedoGuardar" size="sm" variant="primary" @click="AgregaContenido">Agregar</b-button>
      </template>
    </b-modal>
    
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

let Redondeo = function(numero, onzas) {
  let rs = numero;
  let residuo = (numero - parseInt(numero)) * 16;

  rs = parseInt(numero) + (residuo > onzas ? 1 : 0);

  return rs;
};

import addContenido from "./addContenido.vue";

export default {
  computed: {
    DatosGuardar() {
      let rs = this.Pak;
      let frio = false;
      let pks = [];

      this.Pak.Contenido.forEach((pk) => {
        if (pk.Producto.Frio) frio = true;

        pks.push({ Cantidad: pk.Cantidad, Producto: pk.Producto.Nombre, Salud: pk.Producto.Salud });
      });

      let dato = { Peso: rs.Peso, Tipo: rs.Tipo, Frio: frio, Contenido: pks, Cobro: rs.Cobro };

      return dato;
    },
    PuedoGuardar() {
      let p = parseFloat(this.Pak.Peso);
      let cont = this.Pak.Contenido.length > 0;

      return p > 0 && cont;
    },
  },
  props: ["ver", "precio"],
  watch: {
    Peso(v) {
      this.Pak.Peso = v;

      if (v != "") {
        let AjustePeso = Redondeo(parseFloat(v), this.OnzasGracia);
        this.Pak.Cobro = AjustePeso * this.Precio;
      } else {
        this.Pak.Cobro = "";
      }
    },
    ParametrosDB(v) {
      let p = {};
      v.forEach((d) => {
        p[d.id] = d.valor;
      });

      this.OnzasGracia = parseFloat(p.OnzasGracia);
      this.Precio = this.precio;
    },
  },
  data() {
    return {
      Pak: {
        Contenido: [],
        Peso: null,
        Tipo: "Paquete",
        Cobro: 0.0,
        Frio: false,
      },
      Peso: null,
      Precio: 0.0,
      OnzasGracia: null,
      ParametrosDB: null,
    };
  },
  firestore: {
    ParametrosDB: db.collection("Parametros"),
  },
  components: { addContenido },
  methods: {
    onRowClick(...index) {
      this.Pak.Contenido.splice(index[1], 1);
    },
    cerrar() {
      this.$emit("onAgregaPaquete", {
        Contenido: [],
        Peso: null,
        Tipo: "Paquete",
      });
    },
    AgregaContenido() {
      this.$emit("onAgregaPaquete", this.DatosGuardar);
    },
    clean() {
      this.Peso = null;
      this.Pak = { Contenido: [], Peso: null, Tipo: "Paquete" };

      let datos = localStorage.Pak;
      if (datos) {
        datos = JSON.parse(datos);
        if (datos.length) this.Pak.Contenido = datos;
      }
    },
    onAgregarContenido(v) {
      this.Pak.Contenido.push({ ...v });
      localStorage.Pak = JSON.stringify(this.Pak.Contenido);
    },
  },
};
</script>
